// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CardsGridWrapper_wrapper__I7c7f","total":"CardsGridWrapper_total__VhnbL","alternateGrid":"CardsGridWrapper_alternateGrid__Ui57D"};